<template>
	<div>
		<div class="section-title">Who can use this group</div>
		<AppRadioButton v-model="usePermissionType" :choices="usePermissionTypes">
			<template v-slot:label="{ item }">
				<MaybeUpgradeRequiredIndicator :billingFeatureId="item.billingFeatureId" v-if="item.billingFeatureId">
					<template #default="{ indicator, isUpgradeRequired }">
						<GroupPermissionItem :item="item" :indicator="indicator" :isUpgradeRequired="isUpgradeRequired" />
					</template>
				</MaybeUpgradeRequiredIndicator>
				<GroupPermissionItem v-else :item="item" />
			</template>
		</AppRadioButton>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import GroupPermissionItem from './GroupPermissionItem.vue';
import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
import { FeatureTypes } from '@/components/Billing/billing-types';
import { createGroup, updateGroup } from '@/store/modules/accountGroups/actions';
import { groups, defaultGroupName } from '@/store/modules/accountGroups/getters';
import { useHasCapability } from '@/store/modules/billing/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { GROUP_USE_PERMISSION_TYPE } from '@/utils/groups-const';
export default {
	name: 'GroupUsePermission',
	components: { MaybeUpgradeRequiredIndicator, GroupPermissionItem },
	props: {
		group: { type: Object },
	},
	computed: {
		...mapGetters([groups.fullPath, defaultGroupName.fullPath]),
		...mapGettersShorthand({ useHasCapability }),
		usePermissionTypes() {
			return [
				{
					title: `Everyone`,
					value: GROUP_USE_PERMISSION_TYPE.EVERYONE,
				},
				{
					title: `Admins and managers only`,
					value: GROUP_USE_PERMISSION_TYPE.ADMINS_AND_MANAGERS,
					billingFeatureId: FeatureTypes.GroupUsagePermissions,
					disabled: !this.useHasCapability(FeatureTypes.GroupUsagePermissions),
				},
			];
		},
	},
	methods: {
		...mapActions([createGroup.fullPath, updateGroup.fullPath]),
	},
	async mounted() {
		if (this.group) {
			this.usePermissionType = this.group.access_type;
		}
	},
	data: () => ({
		usePermissionType: GROUP_USE_PERMISSION_TYPE.EVERYONE,
	}),
	watch: {
		usePermissionType: {
			handler(val) {
				val && this.$emit('selected-use-permission-type', val);
			},
			immediate: true,
		},
	},
};
</script>

<style scoped lang="scss">
.group-body {
	height: 300px !important;
	overflow: auto !important;
}
.save-button {
	width: 144px !important;
	height: 38px !important;
	font-size: 14px !important;
	border-radius: 3px !important;
	letter-spacing: 0px !important;
	color: var(--white) !important;
	font-weight: normal !important;
	border-color: transparent !important;
	background: var(--forth-color) !important;
}
.label {
	font-size: 14px;
	color: var(--primary-font-color);
}
.section-title {
	@extend .label;
	font-weight: medium;
}
</style>
